import Modal from '../Modal';
import { RequiredGps } from '../Errors';
import { useDispatch, useSelector } from 'react-redux';
import { setGps } from '../../store/reducers/gps';
import { useMemo } from 'react';

const WarningGpsPermission = () => {
	const dispatch = useDispatch();
	const { isShowWarning } = useSelector((store) => store?.gps);

	const handleCloseErrorPermission = () => {
		dispatch(
			setGps({
				isShowWarning: false,
			}),
		);
	};

	const modalProps = useMemo(() => {
		return {
			isOpen: isShowWarning,
			onClose: handleCloseErrorPermission,
		};
	}, [isShowWarning]);

	const gpsProps = {
    className: '!rounded-xl',
		onClose: handleCloseErrorPermission,
	};

	if (!isShowWarning) return null;

	return (
		<Modal {...modalProps}>
			<RequiredGps {...gpsProps} />
		</Modal>
	);
};

export { WarningGpsPermission };
